<app-edtell-front-facing-dialog [config]="frontFacingDialogConfig">
    <div class="row">
        <div class="col-12">
            <p class="text-center">
                {{dialogData.objectData.text}}
            </p>
        </div>
    </div>
</app-edtell-front-facing-dialog>